import styled from 'styled-components';
import { AppBar } from '@mui/material';

export const StyledHeader = styled(AppBar)`
  && {
    position: fixed;
    width: 100%;
    background-color: #1e1e1e;
  }
`;